import { FC } from "react";

import { STEP_TO_ELEMENT_ID } from "@/features/LiveFormEditor/AnimatePreview/Arrow/ArrowContext";
import { FormTypography, FormTypographyProps } from "@/forms-design-system/FormTypography/FormTypography";

type ThemedFormTitleProps = Omit<FormTypographyProps, "ref" | "variant" | "vibe" | "id" | "data-test">;

export const ThemedFormTitle: FC<ThemedFormTitleProps> = ({ children, ...rest }) => {
  return (
    <FormTypography id={STEP_TO_ELEMENT_ID["title"]} data-test="form-title" variant="h4" vibe="intense" {...rest}>
      {children}
    </FormTypography>
  );
};
